<template>
    <div class="chatbox-container">
      <!-- Buton pentru deschiderea chatului -->
      <button class="chatbox-toggle" @click="toggleChat">
        <i v-if="!isOpen" class="fa fa-comment"></i>
        <i v-else class="fa fa-times"></i>
      </button>
  
      <!-- Fereastra chatului -->
      <div v-if="isOpen" class="chatbox">
        <div class="chatbox-header mb-3">
          <h5>{{ $t("chatbox.title") }}</h5>
          <button @click="toggleChat" class="close-btn">&times;</button>
        </div>
  
        <div class="chatbox-body">
          <div v-for="(message, index) in messages" :key="index" class="chatbox-message" :class="{ 'chatbot': message.from === 'bot', 'user': message.from === 'user' }">
            {{ message.text }}
          </div>
  
          <!-- OpÈ›iuni disponibile -->
          <div class="chatbox-options">
            <button v-for="(option, index) in options" :key="index" @click="handleOption(option)" class="chatbox-option">
              {{ option.text }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      isOpen: false,
      isAuthenticated: false,
      userName: "",
      messages: [],
      options: [],
      menuState: "main", // Meniu principal
      menuState2: "main", // Meniu secundar pentru subcategorii
    };
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    this.checkAuth();
  },
  methods: {
    async checkAuth() {
      try {
        const response = await axios.get("https://api.feribot-eurobac.ro/client/api/check-auth/", {
          withCredentials: true,
        });

        if (response.data.isAuthenticated) {
          this.isAuthenticated = true;
          this.userName = response.data.client_name;
        } else {
          this.isAuthenticated = false;
          this.userName = "";
        }
        console.log("🔍 Check Auth: ", this.isAuthenticated ? `User: ${this.userName}` : "Not authenticated");
      } catch (error) {
        this.isAuthenticated = false;
        console.error("❌ Eroare autentificare:", error);
      }
    },
    toggleChat() {
      this.isOpen = !this.isOpen;
      console.log(`🔄 Chat toggled: ${this.isOpen ? "Deschis" : "Închis"}`);
      if (this.isOpen) {
        this.startChat();
      }
    },
    startChat() {
      console.log("🚀 Inițializare chat...");
      this.messages = [];
      this.menuState = "main";
      this.menuState2 = "main";

      let greeting = this.isAuthenticated
        ? this.$t("chatbox.welcomeUser", { name: this.userName })
        : this.$t("chatbox.welcomeGuest");

      this.messages.push({ text: greeting, from: "bot" });
      console.log("💬 Mesaj inițial: ", greeting);

      this.setMainMenu();
    },
    handleOption(option) {
      console.log("👉 Buton apăsat:", option);

      this.messages.push({ text: option.text, from: "user" });

      setTimeout(() => {
        if (option.menuState2 === "back") {
          this.goBack();
        } else if (option.menuState2) {
          console.log("📌 Schimbare meniu:", option.menuState2);
          this.menuState2 = option.menuState2;
          this.showSubOptions();
        } else if (option.action) {
          console.log("➡️ Redirecționare către:", option.action);
          this.messages.push({ text: this.$t("chatbox.redirecting"), from: "bot" });

          setTimeout(() => {
            if (option.action === "/dashboard") {
              console.log(`🔀 Setare tab în Dashboard: ${option.menuState}`);
              localStorage.setItem("menuState", option.menuState || "main");

              if (this.$route.path === "/dashboard") {
                console.log("🔄 Dashboard deja deschis, reîncărcare pagină...");
                window.location.reload();
              } else {
                this.$router.push(option.action);
              }
            } else {
              console.log("🌐 Navigare către:", option.action);
              this.$router.push(option.action);
            }
            this.isOpen = false;
          }, 1500);
        }
      }, 500);
    },
    showSubOptions() {
      console.log("🔄 Actualizare opțiuni pentru:", this.menuState2);
      this.options = [];

      if (this.menuState2 === "accountDetails") {
        this.messages.push({ text: this.$t("chatbox.accountIntro"), from: "bot" });
        this.options = [
          { text: this.$t("chatbox.viewInvoices"), action: "/dashboard", menuState: "facturi" },
          { text: this.$t("chatbox.viewTickets"), action: "/dashboard", menuState: "bilete" },
          { text: this.$t("chatbox.supportTickets"), action: "/dashboard", menuState: "support" },
          { text: this.$t("chatbox.messages"), action: "/dashboard", menuState: "mesaje" },
          { text: this.$t("chatbox.accountInfo"), action: "/dashboard", menuState: "cont" },
          { text: "🔙 " + this.$t("general.back"), menuState2: "main" },
        ];
      } else if (this.menuState2 === "publicInfo") {
        this.messages.push({ text: this.$t("chatbox.publicInfoIntro"), from: "bot" });
        this.options = [
          { text: this.$t("chatbox.managementInfo"), action: "/conducere" },
          { text: this.$t("chatbox.publicInfo"), action: "/informatii-publice" },
          { text: "🔙 " + this.$t("general.back"), menuState2: "main" },
        ];
      }
    },
    goBack() {
      console.log("🔙 Revenire la meniul principal...");
      this.setMainMenu();
    },
    setMainMenu() {
      console.log("📌 Setare meniu principal");
      this.options = this.isAuthenticated
        ? [
            { text: this.$t("chatbox.accountInfo"), menuState2: "accountDetails" },
            { text: this.$t("chatbox.buyTickets"), action: "/bilete" },
            { text: this.$t("chatbox.publicInfo"), menuState2: "publicInfo" },
            { text: this.$t("chatbox.contact"), action: "/contact" },
          ]
        : [
            { text: this.$t("chatbox.login"), action: "/login" },
            { text: this.$t("chatbox.register"), action: "/register" },
            { text: this.$t("chatbox.publicInfo"), menuState2: "publicInfo" },
            { text: this.$t("chatbox.contact"), action: "/contact" },
          ];
    },
  },
};
</script>




<style scoped>
/* Containerul general */
.chatbox-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

/* Butonul de deschidere/Ã®nchidere chat */
.chatbox-toggle {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 12px 18px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
}

.chatbox-toggle:hover {
  background-color: #0056b3;
  transform: scale(1.1);
}

/* Fereastra chatbox-ului */
.chatbox {
  background: white;
  width: 320px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 70px;
  right: 0;
  padding: 12px;
  display: flex;
  flex-direction: column;
  animation: fadeIn 0.3s ease-in-out;
}

/* Header-ul chatului */
.chatbox-header {
  background: #007bff;
  color: white;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

/* Titlul */
.chatbox-header h5 {
  font-size: 16px;
  font-weight: bold;
  margin: 0;
}

/* Butonul de Ã®nchidere */
.close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 16px;
  padding: 5px 10px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.4);
}

/* Mesajele */
.chatbox-message {
  padding: 10px;
  border-radius: 12px;
  max-width: 85%;
  word-wrap: break-word;
  margin-bottom: 10px;
  font-size: 14px;
}

/* Mesajele de la bot */
.chatbot {
  background: #f1f1f1;
  align-self: flex-start;
  border-radius: 12px 12px 12px 0;
}

/* Mesajele utilizatorului */
.user {
  background: #007bff;
  color: white;
  align-self: flex-end;
  border-radius: 12px 12px 0 12px;
}

/* OpÈ›iunile din chat */
.chatbox-options {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
}

/* Butoanele de opÈ›iuni */
.chatbox-option {
  background: #f8f9fa;
  border: none;
  padding: 10px;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.chatbox-option i {
  font-size: 16px;
  color: #007bff;
}

.chatbox-option:hover {
  background: #e9ecef;
  transform: scale(1.02);
}

/* AnimaÈ›ie de apariÈ›ie */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
